(function() {
  'use strict';

  angular
    .module('quiz.labelingItemsInPicture')
    .directive('lipRegion', LipRegion);

  LipRegion.$inject = [];

  function LipRegion() {
    return function(scope, element, attr) {
      element.droppable({
        accept: '.lipDragLabel',
        hoverClass: "active",
        tolerance: "pointer",
        drop: onDrop
      });

      var region;
      scope.$watch(attr.lipRegion, function(value) {
        region = value;
      });

      function onDrop(event, ui) {
        var caption = $(ui.helper.context).scope().caption;
        scope[attr.lipCaptionDragDropCb](region, caption);
      }
    };
  }
})();
